import phone from 'phone'
import { forwardRef } from 'react'
import { PatternFormat } from 'react-number-format'
import { ControlledTextField, type ControlledTextFieldProps } from './TextField'

export type IntlPhoneInputProps = Omit<ControlledTextFieldProps, 'type'>

const InputComponent = forwardRef((props: any, ref) => {
  const {
    name,
    value,
    className,
    onAnimationStart,
    onBlur,
    onChange,
    onFocus,
  } = props

  return (
    <PatternFormat
      getInputRef={ref}
      name={name}
      value={value}
      className={className}
      format="(###) ###-####"
      onAnimationStart={onAnimationStart}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
    />
  )
})

export function IntlPhoneInput({ validate, ...props }: IntlPhoneInputProps) {
  return (
    <ControlledTextField
      {...props}
      type="tel"
      validate={{
        ...(typeof validate === 'function' ? { validate } : validate),
        isValidPhoneNumber: (value) => !value || phone(value).isValid,
      }}
      InputProps={{
        inputComponent: InputComponent,
      }}
    />
  )
}
